import React from "react";
import "../assets/css/App.css";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { Link } from "react-router-dom";
import { Breadcrumb } from "antd";

class Public extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      navColor: {
        backgroundColor: "rgb(0,21,41)"
      },
      brandStyle: {
        fontSize: 34,
        fontWeight: "bold",
        color: "white",
        textAlign: "center"
      },
      navLinkStyle: {
        fontSize: 18,
        fontWeight: "bold",
        color: "white",
        padding: "0 6px",
        whiteSpace: "nowrap"
      },
      dropdownToggleStyle: {
        fontSize: 18,
        fontWeight: "bold",
        color: "white",
        background: "transparent",
        border: "none",
        padding: "0 6px",
        whiteSpace: "nowrap"
      },
      dropdownMenuStyle: {
        minWidth: 260,
        borderRadius: 10,
        padding: "8px 0",
        boxShadow: "0 6px 18px rgba(0,0,0,0.12)"
      },
      dropdownItemStyle: {
        fontSize: 15,
        padding: "10px 18px"
      }
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <div>
        <Navbar style={this.state.navColor} dark expand="xl" className="px-4">
          <NavbarBrand
            href="/"
            style={this.state.brandStyle}
            className="navbrand"
          >
            CIITOOL
          </NavbarBrand>

          <NavbarToggler
            onClick={this.toggle}
            style={{ backgroundColor: "rgb(220,220,200)" }}
          />

          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto align-items-xl-center" navbar>
              <NavItem className="mx-xl-2">
                <NavLink tag={Link} to="/" style={this.state.navLinkStyle}>
                  Home
                </NavLink>
              </NavItem>

              <UncontrolledDropdown nav inNavbar className="mx-xl-2">
                <DropdownToggle nav caret style={this.state.dropdownToggleStyle}>
                  Tools
                </DropdownToggle>
                <DropdownMenu right style={this.state.dropdownMenuStyle}>
                  <DropdownItem tag={Link} to="/mifa" style={this.state.dropdownItemStyle}>
                    Medical Image Feature Atlas
                  </DropdownItem>
                  <DropdownItem tag={Link} to="/hcc" style={this.state.dropdownItemStyle}>
                    Hepatocellular Carcinoma
                  </DropdownItem>
                  <DropdownItem tag={Link} to="/bicomb" style={this.state.dropdownItemStyle}>
                    Bicomb
                  </DropdownItem>
                  <DropdownItem tag={Link} to="/clarityICI" style={this.state.dropdownItemStyle}>
                    CLARITY-ICI Matrix
                  </DropdownItem>
                  <DropdownItem tag={Link} to="/irAEs" style={this.state.dropdownItemStyle}>
                    irAEs
                  </DropdownItem>
                  <DropdownItem tag={Link} to="/Diameter" style={this.state.dropdownItemStyle}>
                    Diameter
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>

              <UncontrolledDropdown nav inNavbar className="mx-xl-2">
                <DropdownToggle nav caret style={this.state.dropdownToggleStyle}>
                  Language
                </DropdownToggle>
                <DropdownMenu right style={this.state.dropdownMenuStyle}>
                  <DropdownItem tag={Link} to="/Chinese" style={this.state.dropdownItemStyle}>
                    Chinese
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>

              <NavItem className="mx-xl-2">
                <NavLink
                  tag={Link}
                  to="/continue"
                  style={this.state.navLinkStyle}
                >
                  Contact Us
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>

        <Breadcrumb style={{ padding: "16px 50px" }}>
          <Breadcrumb.Item>
            <Link to="/">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/Chinese">Chinese</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/contact">Contact</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
    );
  }
}

export default Public;